import React, { useState, useEffect } from 'react';
import './CSS/BankingPaymentPage.css';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import axios from 'axios'; // For making API requests

const ReservationPage = () => {
  const [roomType, setRoomType] = useState('');
  const [numPersons, setNumPersons] = useState('');
  const [checkInDate, setCheckInDate] = useState(new Date());
  const [checkOutDate, setCheckOutDate] = useState(new Date());
  const [totalAmount, setTotalAmount] = useState(null);
  const [errorMessage, setErrorMessage] = useState('');
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [customerName, setCustomerName] = useState('');
  const [contactNumber, setContactNumber] = useState('');
  const [email, setEmail] = useState('');
  const [rooms, setRooms] = useState([]); // Available rooms
  const [unavailableDates, setUnavailableDates] = useState([]); // Unavailable dates for booking
  const [PerNight, setPerNight] = useState(false);
  const [isReservationSubmitted, setIsReservationSubmitted] = useState(false);
  const [paymentId, setPaymentId] = useState(null);
  const [screenshotFile, setScreenshotFile] = useState(null);
  const [isScreenshotUploaded, setIsScreenshotUploaded] = useState(false);
  const [bankDetails, setBankDetails] = useState({
    bank_name: 'Loyds Bank',
    account_name: 'Litchfield property Ltd',
    account_number: '11252768',
    sort_code: '30-54-66'
  });
  const [showReservationModal, setShowReservationModal] = useState(false);
  const [showPaymentModal, setShowPaymentModal] = useState(false);

  // Fetch available rooms on mount
  useEffect(() => {
    const fetchRooms = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/rooms`); 
        setRooms(response.data);
      } catch (error) {
        console.error('Error fetching rooms:', error);
        setErrorMessage('Failed to fetch rooms.');
      }
    };
    fetchRooms();
  }, []);

  const fetchUnavailableDates = async (roomType) => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/rooms/${roomType}/unavailable_dates`);
      
      if (response.data.unavailable_dates) {
        const formattedDates = response.data.unavailable_dates.map(date => date.split('T')[0]); // Convert to "YYYY-MM-DD"
        setUnavailableDates(formattedDates);
      }
    } catch (error) {
      console.error('Error fetching unavailable dates:', error);
      setErrorMessage('Failed to fetch unavailable dates.');
    }
  };
  
  

// Room pricing logic based on room type, number of persons, and day of the week
const getRoomPrice = (roomType, numPersons, dayOfWeek) => {
  let pricePerNight = 0;
  numPersons = Number(numPersons);
  
  // Determine if it's a weekend
  const isWeekend = ['Friday', 'Saturday', 'Sunday'].includes(dayOfWeek);
  
  switch (roomType) {
    case 'family':
      pricePerNight = isWeekend ? 67 : 57;
      break;
    case 'double':
      pricePerNight = isWeekend ? 47 : 37;
      break;
    case 'twin':
      pricePerNight = isWeekend ? 48.5 : 38.5;
      break;
    default:
      pricePerNight = 0;
  }
  setPerNight(pricePerNight)
  // Ensure correct pricing based on number of occupants
  if (roomType === 'family' && numPersons > 5) return 0;
  if ((roomType === 'double' || roomType === 'twin') && (numPersons > 2)) return 0;

  return pricePerNight;
};

  const handleCalculate = () => {
    setErrorMessage('');
    if (!roomType || !numPersons || !checkInDate || !checkOutDate) {
      setErrorMessage('Please fill in all fields');
      return;
    }

    const timeDifference = new Date(checkOutDate) - new Date(checkInDate);
    const numNights = timeDifference / (1000 * 3600 * 24);

    if (numNights <= 0) {
      setErrorMessage('Check-out date must be after check-in date');
      return;
    }

    const checkInDay = new Intl.DateTimeFormat('en-US', { weekday: 'long' }).format(checkInDate);

    // Get price based on room type, number of persons, and check-in day
    const pricePerNight = getRoomPrice(roomType, numPersons, checkInDay);
    if (pricePerNight === 0) {
      setErrorMessage('Invalid room selection for the number of persons');
      return;
    }

    const total = pricePerNight * numNights;
    setTotalAmount(total);
  };

  const handleSubmitReservation = async (event) => {
    event.preventDefault();
  
    if (!customerName || !contactNumber || !email) {
      setErrorMessage('Please fill in all required fields.');
      return;
    }
  
    const data = {
      room_type: roomType,
      num_persons: numPersons,
      check_in_date: checkInDate.toISOString().split('T')[0],
      check_out_date: checkOutDate.toISOString().split('T')[0],
      amount: totalAmount,
      customer_name: customerName,
      contact_number: contactNumber,
      email: email,
      price_per_night: PerNight,
      bank_name: bankDetails.bank_name,
      account_number: bankDetails.account_number,
      sort_code: bankDetails.sort_code,
      account_name: bankDetails.account_name
    };
  
    try {
      const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/reserve`, data);
      setPaymentId(response.data.payment_id);
      setIsReservationSubmitted(true);
      setErrorMessage('');
      setShowReservationModal(false);
      setShowPaymentModal(true);
    } catch (error) {
      console.error('Error submitting reservation:', error);
      setErrorMessage('Failed to submit reservation.');
    }
  };

  const handleScreenshotUpload = async (event) => {
    event.preventDefault();
    
    if (!screenshotFile) {
      setErrorMessage('Please select a screenshot file.');
      return;
    }

    const formData = new FormData();
    formData.append('screenshot', screenshotFile);
    formData.append('reservation_id', paymentId);
    formData.append('amount', totalAmount);
    formData.append('bank_name', bankDetails.bank_name);
    formData.append('account_number', bankDetails.account_number);
    formData.append('sort_code', bankDetails.sort_code);
    formData.append('account_name', bankDetails.account_name);

    try {
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/payment/bank-transfer`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      setIsScreenshotUploaded(true);
      setErrorMessage('');
      setShowPaymentModal(false);
      alert('Payment details submitted successfully! Your reservation will be reviewed by our team.');
    } catch (error) {
      console.error('Error submitting payment details:', error);
      setErrorMessage('Failed to submit payment details.');
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setScreenshotFile(file);
    }
  };

  const closePopup = () => {
    setIsPopupVisible(false);
  };

  return (
    <div className="payment-container">
      <h1 className="payment-title">Room Reservation</h1>

      <div className="form-container">
        <form onSubmit={(e) => e.preventDefault()} className="reservation-form">
        <label className="form-label">
          Room Type:
          <select
            className="form-select"
            value={roomType}
            onChange={(e) => {
              setRoomType(e.target.value);
              fetchUnavailableDates(e.target.value); // Fetch available dates when room type changes
            }}
            required
          >
            <option value="">Select Room Type</option>
            {[...new Set(rooms.map((room) => room.room_type))].map((type) => (
              <option key={type} value={type}>
                {type === 'family' ? 'Family Room' :
                type === 'double' ? 'Double Room' :
                type === 'twin' ? 'Twin Room' :
                type}
              </option>
            ))}
          </select>
        </label>


          <label className="form-label">
            Number of Persons:
            <input
              className="form-input"
              type="number"
              value={numPersons}
              onChange={(e) => setNumPersons(e.target.value)}
              required
              min="1"
              style={{ width: '95%' }}
            />
          </label>

          <label className="form-label">
            Check-in Date:
            <DatePicker
              selected={checkInDate}
              onChange={(date) => setCheckInDate(date)}
              dateFormat="MMMM d, yyyy"
              minDate={new Date()}
              required
              filterDate={(date) => {
                const formattedDate = date.toISOString().split('T')[0]; // Ensure format is "YYYY-MM-DD"
                return !unavailableDates.includes(formattedDate);
              }}
              className="form-datepicker"
            />

          </label>
          <label className="form-label">
            Check-out Date:
            <DatePicker
              selected={checkOutDate}
              onChange={(date) => setCheckOutDate(date)}
              dateFormat="MMMM d, yyyy"
              minDate={checkInDate}
              filterDate={(date) =>
                !unavailableDates.includes(date.toISOString().split('T')[0]) // Disable unavailable dates
              }
              className="form-datepicker"
              required
            />
          </label>

          <button type="button" onClick={handleCalculate} className="calculate-button">
            Calculate Total
          </button>
        </form>

        {errorMessage && <div className="error-message"><p>{errorMessage}</p></div>}

        {totalAmount !== null && !errorMessage && (
          <div className="payment-summary">
            <h3>Total Amount: £{totalAmount.toFixed(2)}</h3>
          </div>
        )}

        {totalAmount !== null && !errorMessage && (
          <button type="button" onClick={() => setShowReservationModal(true)} className="pay-now-button">
            Book Now
          </button>
        )}
      </div>

      {/* Reservation Details Modal */}
      {showReservationModal && (
        <div className="modal">
          <div className="modal-content">
            <h2>Reservation Details</h2>
            <form onSubmit={handleSubmitReservation}>
              <label className="form-label">
                Full Name:
                <input
                  className="form-input"
                  type="text"
                  value={customerName}
                  onChange={(e) => setCustomerName(e.target.value)}
                  required
                />
              </label>

              <label className="form-label">
                Contact Number:
                <input
                  className="form-input"
                  type="tel"
                  value={contactNumber}
                  onChange={(e) => setContactNumber(e.target.value)}
                  required
                />
              </label>

              <label className="form-label">
                Email Address:
                <input
                  className="form-input"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </label>

              <div className='form-buttons'>
                <button type="submit" className="submit-reservation-button">
                  Submit Reservation
                </button>
                <button type="button" onClick={() => setShowReservationModal(false)} className="close-modal-button">
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Payment Details Modal */}
      {showPaymentModal && (
        <div className="modal">
          <div className="modal-content">
            <h2>Payment Details</h2>
            <div className="bank-details">
              <h3>Bank Transfer Details</h3>
              <p><strong>Bank:</strong> {bankDetails.bank_name}</p>
              <p><strong>Account Name:</strong> {bankDetails.account_name}</p>
              <p><strong>Account Number:</strong> {bankDetails.account_number}</p>
              <p><strong>Sort Code:</strong> {bankDetails.sort_code}</p>
              <p><strong>Amount to Transfer:</strong> £{totalAmount.toFixed(2)}</p>
              <p><strong>Reference:</strong> {paymentId}</p>
              <p className="note">Please use the payment ID as the reference when making the transfer.</p>
              
              <div className="screenshot-upload">
                <h4>Upload Payment Screenshot</h4>
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleFileChange}
                  className="file-input"
                />
                <button
                  type="button"
                  onClick={handleScreenshotUpload}
                  className="upload-button"
                  disabled={!screenshotFile || isScreenshotUploaded}
                >
                  {isScreenshotUploaded ? 'Screenshot Uploaded' : 'Upload Screenshot'}
                </button>
              </div>
            </div>

            <div className='form-buttons'>
              <button type="button" onClick={() => setShowPaymentModal(false)} className="close-modal-button">
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ReservationPage;
